const VPN_OR_PROXY_LOGIN_ERROR = 'Tenemos un inconveniente al tratar de iniciar tu sesión.'
    + ' ¿Tienes activa una VPN o un proxy? Desactívala y vuelve a intentarlo.';
export default VPN_OR_PROXY_LOGIN_ERROR;
